import Amplify, { Auth, Analytics } from "aws-amplify";
import _ from "lodash";

import {
  USER_LOGIN_FAIL,
  USER_LOGIN_SUCCESS,
  USER_SIGNUP_SUCCESS,
  USER_SIGNUP_FAIL,
  USER_LOGOUT,
  COGNITO_USER_LOGIN_FAIL,
  COGNITO_USER_LOGIN_SUCCESS,
  UPDATE_TOKENS,
  RESETUP_AUTH,
  CHANGE_USER_ATTRIBUTE_SUCCESS,
  UPDATE_TENANT,
} from "../actions/auth";
import { addEventNameToEndpoint } from "../utils/common";

const oauthSettings = {
  domain: process.env.REACT_APP_API_SERVER_BASE_URL,
  scope: [
    "phone",
    "email",
    "profile",
    "openid",
    "aws.cognito.signin.user.admin",
  ],
  redirectSignIn: "/signin",
  redirectSignOut: "/",
  responseType: "code", // or token
};

// const eventName = [
//   // '_userauth.sign_up',
//   'user-tag-add',
//   'user-filterContentType-select',
//   'user-mainViewGrid-select',
//   'user-mainViewList-select',
//   'user-filterFunnelStage-select',
//   'user-filterVoted-select',
//   'user-filterFavorites-select',
//   'user-filterPopular-select',
//   'user-filterOrderType-select',
//   'user-item-add',
//   'admin-item-add',
//   'admin-contentType-delete',
//   'admin-funnelStage-delete',
//   'admin-tag-delete',
//   'admin-auth-confirmed',
//   'user-auth-confirmed',
//   'admin-item-import',
//   'admin-delete-import-history',
//   'admin-user-invite',
//   'admin-user-delete',
//   '_userauth.auth_fail',
//   '_userauth.sign_in',
//   'admin-create-new-collection',
//   'user-wishlistItem-delete',
//   'user-shorturl-copy',
//   'user-shorturl-share',
//   'user-item-upvote',
//   'user-item-unupvote',
//   'user-item-unfavorite',
//   'user-item-favorite',
//   'user-wishlistItem-unupvote',
//   'user-wishlistItem-upvote',
//   'user-extension-ctaClick',
//   'admin-tag-edit',
//   'admin-contentType-edit',
//   'admin-contentType-add',
//   'admin-funnelStage-edit',
//   'admin-funnelStage-add',
//   'admin-shorturl-customize',
//   'user-paywall-subscribe',
//   'user-paywall-contact'
// ];

const authSettings = {
  mandatorySignIn: false,
  region: "us-west-2",
};

// const initialState = {
//   Auth: null,
//   Analytics: null,
//   AuthConfig: null,
//   tenant: null,
//   cognitoUser: null,
//   isAuthenticated: false,
//   error: null
// };

const initialState = {};

// Amplify.Logger.LOG_LEVEL = 'DEBUG';

const analyticsSettings = {
  // disable to control event that are sent (session start, login)
  disabled: true,
  // OPTIONAL - Allow recording session events. Default is true.
  autoSessionRecord: true,
  AWSPinpoint: {
    appId: process.env.REACT_APP_PINPOINT_ID,
    region: "us-east-1",
    // OPTIONAL -  Customized endpoint
    // endpointId: "",
    // OPTIONAL - Default Endpoint Information
    endpoint: {
      // address: "", // The unique identifier for the recipient. For example, an address could be a device token, email address, or mobile phone number.
      attributes: {
        // Custom attributes that your app reports to Amazon Pinpoint. You can use these attributes as selection criteria when you create a segment.
        // tenantId: "",
      },
      channelType: "EMAIL",
      /** Indicates whether a user has opted out of receiving messages with one of the following values:
       * ALL - User has opted out of all messages.
       * NONE - Users has not opted out and receives all messages.
       */
      optOut: "NONE",
      // Customized userId
      userId: "",
      // User attributes
      userAttributes: {
        // tenantId: 'DEVXXXX'
        // ...
      },
    },
  },
};

const configureAnalytics = async (user) => {
  const { userId, tenantId, email, companyName, emailDomain, role } = user;

  analyticsSettings.disabled = false;
  analyticsSettings.AWSPinpoint.endpointId = userId;
  analyticsSettings.AWSPinpoint.endpoint.address = email;
  analyticsSettings.AWSPinpoint.endpoint.attributes.tenantId = [tenantId];
  analyticsSettings.AWSPinpoint.endpoint.attributes.eventName =
    analyticsSettings.AWSPinpoint.endpoint.attributes.eventName || [];
  analyticsSettings.AWSPinpoint.endpoint.userId = userId;
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.tenantId = [tenantId];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.userId = [userId];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.companyName = [
    companyName,
  ];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.emailDomain = [
    emailDomain,
  ];
  analyticsSettings.AWSPinpoint.endpoint.userAttributes.role = [role];
  // not sure if we can configure just Analytics at this point
  Analytics.configure(analyticsSettings);
  Analytics.autoTrack("session", {
    enable: true,
    attributes: {
      tenantId,
      userId
    },
  });

  Analytics.autoTrack("pageView", {
    enable: true,
    eventName: "user-page-view",
    attributes: {
        tenantId,
        userId
    },
    type: "SPA",
    getUrl: () => {
      // the default function
      return window.location.origin + window.location.pathname;
    },
  });
  // Analytics.autoTrack('event', {
  //   enable: true,
  //   // OPTIONAL, events you want to track, by default is 'click'
  //   events: ['click'],
  //   selectorPrefix: 'data-cc-analytics-',
  //   attributes: {
  //       tenantId
  //   }
  // });
  Analytics.autoTrack("event", {
    // REQUIRED, turn on/off the auto tracking
    enable: true,
    // OPTIONAL, events you want to track, by default is 'click'
    events: ["click"],
    // OPTIONAL, the prefix of the selectors, by default is 'data-amplify-analytics-'
    // in order to avoid collision with the user agent, according to https://www.w3schools.com/tags/att_global_data.asp
    // always put 'data' as the first prefix
    selectorPrefix: "data-cc-analytics-",
    // OPTIONAL, the service provider, by default is the AWS Pinpoint
    provider: "AWSPinpoint",
    // OPTIONAL, the default attributes of the event, you can either pass an object or a function
    // which allows you to define dynamic attributes
    attributes: {
      tenantId,
      userId
    }
  });

  Analytics.enable();
  // Authentication Events
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_FAIL:
      return {
        ...state,
        error: action.error,
        isAuthenticated: false,
        tenant: null,
      };
    case USER_LOGIN_SUCCESS:
      authSettings.userPoolId = action.user.userPoolId;
      authSettings.identityPoolId = action.user.identityPoolId;
      authSettings.userPoolWebClientId = action.user.appClientId;
      oauthSettings.domain = action.user.appClientDomain;
      authSettings.mandatorySignIn = false;

      if (process.env.REACT_APP_ENVIRONMENT !== "local") {
        const userId = action.user.ownerId;
        const tenantId = action.user.tenantId;
        const email = action.user.ownerEmail;
        const emailDomain = email.split("@")[1];
        localStorage.setItem("email", email);
        configureAnalytics({
          userId,
          tenantId,
          email,
          emailDomain,
          companyName: action.user.companyName,
          role: "admin",
        });
      }

      Amplify.configure({
        Auth: authSettings,
        Analytics: analyticsSettings,
      });

      return {
        ...state,
        Auth,
        AuthConfig: Auth._config.Auth,
        Analytics,
        error: null,
        tenant: action.user,
      };
    case UPDATE_TENANT:
      return {
        ...state,
        tenant: action.tenant,
      };
    case USER_LOGOUT:
      return {};
    case USER_SIGNUP_FAIL:
      return {
        ...state,
        error: action.error,
        isAuthenticated: false,
        tenant: null,
      };
    case USER_SIGNUP_SUCCESS:
      return {
        ...state,
        error: null,
        isAuthenticated: false,
        tenant: action.user,
      };
    case COGNITO_USER_LOGIN_FAIL:
      if (state.tenant) {
        if (process.env.REACT_APP_ENVIRONMENT !== "local") {
          const userId = state.tenant.ownerId;
          const tenantId = state.tenant.tenantId;
          const email = state.tenant.ownerEmail;
          const emailDomain = email.split("@")[1];

          authSettings.userPoolId = state.tenant.userPoolId;
          authSettings.identityPoolId = state.tenant.identityPoolId;
          authSettings.userPoolWebClientId = state.tenant.appClientId;
          authSettings.mandatorySignIn = false;

          configureAnalytics({
            userId,
            tenantId,
            email,
            emailDomain,
            companyName: state.tenant.companyName,
            role: "admin",
          });

          Amplify.configure({
            Auth: authSettings,
            Analytics: analyticsSettings,
          });
        }

        addEventNameToEndpoint(Analytics, "_userauth.auth_fail");
        Analytics.record({
          name: "_userauth.auth_fail",
          attributes: {
            tenantId: state.tenant.tenantId,
          },
        });
      }

      return {
        ...state,
        error: action.error,
        isAuthenticated: false,
        cognitoUser: null,
      };
    case COGNITO_USER_LOGIN_SUCCESS: {
      const cognitoUser = {
        ...state.cognitoUser,
        ...action.user,
        attributes: {
          ...action.user.attributes,
        },
      };

      if (process.env.REACT_APP_ENVIRONMENT !== "local") {
        const userId = _.get(cognitoUser, "username");
        const tenantId = _.get(cognitoUser, "attributes['custom:tenant_id']");
        const email = _.get(cognitoUser, "attributes.email");
        const emailDomain = email.split("@")[1];

        configureAnalytics({
          userId,
          tenantId,
          email,
          emailDomain,
          companyName:
            state.tenant && state.tenant.companyName
              ? state.tenant.companyName
              : "",
          role: _.get(cognitoUser, "attributes['custom:role']"),
        });
      }

      Amplify.configure({
        Analytics: analyticsSettings,
      });

      const eventNames =
        Analytics._config.AWSPinpoint.endpoint.attributes.eventName || [];
      if (!eventNames.includes("_userauth.sign_in")) {
        Analytics.updateEndpoint({
          attributes: {
            eventName: [...eventNames, "_userauth.sign_in"],
          },
        });
      }

      addEventNameToEndpoint(Analytics, "_userauth.sign_in");
      Analytics.record({
        name: "_userauth.sign_in",
        attributes: {
          tenantId: _.get(cognitoUser, "attributes['custom:tenant_id']"),
        },
      })
        .then((res) => {
          // console.log('sign in event tracking: ', res);
        })
        .catch((error) => console.log("sign in event tracking error: ", error));

      return {
        ...state,
        Auth,
        Analytics,
        AuthConfig: Auth._config.Auth,
        error: null,
        cognitoUser: { ...cognitoUser },
        isAuthenticated: true,
      };
    }
    case UPDATE_TOKENS:
      const { cognitoUser } = state;
      if (cognitoUser) {
        cognitoUser.signInUserSession = action.tokens;
      }

      return {
        ...state,
        cognitoUser: {
          ...cognitoUser,
        },
      };
    case RESETUP_AUTH: {
      if (process.env.REACT_APP_ENVIRONMENT !== "local" && state.cognitoUser) {
        const userId = _.get(state.cognitoUser, "username");
        const tenantId = _.get(
          state.cognitoUser,
          "attributes['custom:tenant_id']"
        );
        const email = _.get(state.cognitoUser, "attributes.email");
        const emailDomain = email.split("@")[1];

        configureAnalytics({
          userId,
          tenantId,
          email,
          emailDomain,
          companyName: state.tenant.companyName,
          role: _.get(state.cognitoUser, "attributes['custom:role']"),
        });
      }

      Amplify.configure({
        Auth: state.AuthConfig,
        Analytics: analyticsSettings,
      });

      return {
        ...state,
        Auth,
        Analytics,
      };
    }
    case CHANGE_USER_ATTRIBUTE_SUCCESS: {
      const { cognitoUser } = state;
      if (action.params.name === "state" && cognitoUser) {
        cognitoUser.attributes["custom:state"] = action.params.value;
      }
      if (action.params.name === "name" && cognitoUser) {
        cognitoUser.attributes.name = action.params.value;
      }

      return {
        ...state,
        cognitoUser: {
          ...cognitoUser,
        },
      };
    }
    default:
      return state;
  }
};

export default AuthReducer;
